'use client';

import { ProjectSectionElement } from '@/app/[locale]/(business)/projects/[slug]/types';
import Link from '@/lib/translation/components/link';

import { cn } from '@/lib/utils';

interface DetailProjectPageNavigationProps {
  disabled?: boolean;
  sectionsToDisplay: ProjectSectionElement[];
  hash?: string | null | undefined;
}

const DetailProjectPageNavigation = ({
  disabled,
  sectionsToDisplay,
  hash,
}: DetailProjectPageNavigationProps) => {
  return (
    <div className="sticky top-20 z-20 flex justify-between bg-white md:overflow-x-visible">
      {sectionsToDisplay.map((tab) => {
        return (
          <Link
            href={tab.anchor}
            key={tab.name}
            className={cn(
              'group grow rounded-none border-b-2 border-border px-2 py-4 text-foreground ring-0 hover:cursor-pointer hover:border-primary hover:text-primary focus-visible:ring-0',
              hash === tab.anchor ? 'border-primary text-primary' : '',
              {
                'pointer-events-none': disabled,
              },
            )}
            rel="nofollow"
          >
            <div className="flex flex-row items-center justify-center gap-2">
              {tab.icon ? (
                <div className="hidden size-4 md:block">{tab.icon}</div>
              ) : null}
              <span>{tab.label}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default DetailProjectPageNavigation;
